<template>
	<div id="ScrollView" ref="ScrollView">
		<slot/>
	</div>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';

	@Component({
		components: {},
	})
	export default class ScrollView extends Vue {
		@Prop(Number) scrollTop;

		mounted() {
			if (typeof scrollTop === 'number') {
				this.$refs.ScrollView.scrollTop = scrollTop;
			}
		}

		get offsetHeight() {
			console.log('scrollview', this.$refs.ScrollView, this.$refs.ScrollView.offsetHeight);
			return this.$refs.ScrollView.offsetHeight;
		}
	}
</script>

<style lang="scss">
	#ScrollView {
		overflow: auto;
		position: relative;
		max-height: 100%;
	}

	#ScrollView::-webkit-scrollbar {
		background-color: transparent;
	}

	#ScrollView::-webkit-scrollbar-track {
		background: url(../../assets/img/bg.png);
	}

	#ScrollView::-webkit-scrollbar-thumb {
		background: url(../../assets/img/bg.png);
		background-position: center center;
	}

	#ScrollView.invert-color::-webkit-scrollbar-track {
		background: url(../../assets/img/bg_inverted.png);
	}

	#ScrollView.invert-color::-webkit-scrollbar-thumb {
		background: url(../../assets/img/bg_inverted.png);
		background-position: center center;
	}
</style>